<template>

    <!-- TEMPLATE MESSAGGIO SEMPLICE -->
        <div v-if="message.tipo_post === 'messaggio'" class="messaggio-container" :class="{'reverse': ruolo === 'utente' ? message.avatar?.ordine !== 'reverse' : message.avatar?.ordine === 'reverse'}">
            <div :class="message.tipo_post">
                <div v-html="messaggio_lavorato" class="message-content"></div>
                <div v-if="message.allegati && message.allegati.length > 0" class="allegati-chat">
                <p class="info-label">Allegati</p>
                <ul>
                    <li v-for="allegato in message.allegati" :key="allegato.id">
                        <a :href="getAllegatoUrl(allegato.id, allegato.tabella, allegato)" target="_blank" class="allegato-link">
                            <i class="pi pi-paperclip"></i> {{ allegato.nome }}
                        </a>
                    </li>
                </ul>
                </div>
                <p class="bottom-dataora">{{ formatDate(message.creato) }}</p>
            </div>
            <div class="avatar" :style="`background-color: ${message.avatar.colore}`">
            {{ message?.avatar?.iniziali }}
            </div>
        </div>
    <!-- END TEMPLATE MESSAGGIO SEMPLICE -->
    <!-- TEMPLATE NOTA INTERNA -->
          <div v-else-if="message.tipo_post === 'nota_interna'" class="messaggio-container">
              <div class="messaggio nota_interna">
                <div class="intestazione_messaggio">
                  <p>
                    <b>{{ message.nome_dipendente }} {{ message.cognome_dipendente }}</b> ha aggiunto una nota
                  </p>
                  <p>
                    {{ formatDate(message.creato) }}
                  </p>
                </div>
                <div>
                  <p v-html="messaggio_lavorato"></p>
                  <div v-if="message.allegati && message.allegati.length > 0" class="allegati-chat">
                    <b>Allegati:</b>
                    <ul>
                      <li v-for="allegato in message.allegati" :key="allegato.id">
                        <i class="pi pi-paperclip mr-2"></i><a :href="getAllegatoUrl(allegato.id, allegato.tabella, allegato)" >{{ allegato.nome }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="avatar" :style="`background-color: ${message.avatar.colore}`">
                {{ message?.avatar?.iniziali }}
              </div>
          </div>
    <!-- END TEMPLATE NOTA INTERNA -->
    <!-- TEMPLATE ASSEGNAZIONE -->

          <div v-else-if="message.tipo_post === 'assegnazione'" class="messaggio-container">
            <div class="messaggio assegnazione">
              <div class="intestazione_messaggio">
                <p>
                  <b>{{ message.nome_dipendente }} {{ message.cognome_dipendente }}</b> {{  $root.trans.lavora_ticket }}
                </p>
                <p class="dataora">
                  {{ formatDate(message.creato) }}
                </p>
              </div>
            </div>
          </div>
    <!-- END TEMPLATE ASSEGNAZIONE -->
    <!-- TEMPLATE ORE-->

          <div v-else-if="message.tipo_post === 'ore' && (ruolo && ruolo == 'admin' || ruolo == 'dipendente')" class="messaggio-container">
              <div class="messaggio ore">
                <div class="intestazione_messaggio">
                  <p>
                    <b>{{ message.nome_dipendente }} {{ message.cognome_dipendente }}</b> ha modificato le ore lavorative
                  </p>
                  <p>
                    {{ formatDate(message.creato) }}
                  </p>
                </div>
                <div>
                  <UnlockAndSaveInput
                    v-model="ore"
                    :label="$root.trans.ticket_ore"
                    :min="0"
                    :step="step"
                    :min-fraction-digits="0"
                    :max-fraction-digits="0"
                    :start-in-edit-mode="false"
                    :save-url="`/${ruolo}/ticketing/thread/salva_ore`"
                    save-key="ore"
                    :can-edit="(ruolo == 'admin' || ruolo == 'dipendente') && !isReadonly"
                    :additional-data="{ id: message.id }"
                    display-prefix="ore: "
                    @value_saved="handleSaved"
                    @save-error="handleError"
                  />
                </div>
              </div>
              <div class="avatar" :style="`background-color: ${message.avatar.colore}`">
                {{ message?.avatar?.iniziali }}
              </div>
          </div>
    <!-- END TEMPLATE ORE-->
     <!-- TEMPLATE MESSAGGIO ERRORE -->
      <div v-else-if="message.tipo_post === 'errore'" class="messaggio-container">
            <div class="messaggio errore">
                <div v-html="sanitize(message.messaggio)" class="message-content"></div>

            </div>
        </div>
    <!-- END TEMPLATE MESSAGGIO ERRORE -->

</template>

<script>
import DOMPurify from 'dompurify';
import PrimeDrawer from 'primevue/drawer';
import Button from 'primevue/button';
import Input from 'primevue/inputtext';
import Tag from 'primevue/tag';
import InputNumber from 'primevue/inputnumber';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import FloatLabel from 'primevue/floatlabel';
import UnlockAndSaveInput from './UnlockAndSaveInput.vue';
export default {
  name: 'MessaggioChat',
  components: {
    PrimeDrawer,
    Button,
    Input,
    InputGroup,
    InputNumber,
    InputGroupAddon,
    FloatLabel,
    Tag,
    UnlockAndSaveInput
  },
  emits: ['ore_saved'],
  data(){
   return {
    show_edit_ore: this.edit_ore || false,
    ore: 0
   }
  },
  computed:{
    messaggio_lavorato: function(){
      const msg = this.message.messaggio.replace(/&nbsp;/gi," ").replace(/\!important/gi, "");
      return DOMPurify.sanitize(msg);
    }
  },
  mounted(){
    console.log(this.edit_ore);
    console.log(this.message);

    if(this.message.tipo_post !== 'ore' || !this.message.ore) return null;
    if(!isNaN(parseInt(this.message.ore)) && parseInt(this.message.ore).toString() == this.message.ore){
      this.ore = parseInt(this.message.ore);

    }else{

      //this.ore = this.message.ore;
      const arr_ore = this.message.ore.split(':');
        const ore = parseInt(arr_ore[0]) || 0;
        const minuti = parseInt(arr_ore[1]) || 0;

        this.ore = ore * 60 + minuti;
    }
  },
  props: [
    'message',
    'edit_ore',
    'ruolo',
    'step',
    'isReadonly'
  ],
  methods: {

    sanitize(html) {
      return DOMPurify.sanitize(html);
    },

    getAllegatoUrl(id, type, allegato){
      if(allegato && allegato.url) return allegato.url;
      return route('ticketing/allegato', { id: id, tipo: type });
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    handleSaved(data) {
      this.$emit('ore_saved', data);

    },
    handleError(error) {
      console.error('Errore durante la modifica delle ore:', error);
      this.$toast.add({
        severity:'error',
        summary:this.$root.trans.ticket_aggiornato_fallito,
        life:5000
      });
    }

  }
}
</script>
